import React from "react";
import NoDataFound from "../common/NoDataFound";

const CricketPlayerTable = ({ team1Players, team2Players }) => {
  const maxLength = Math.max(team1Players?.length, team2Players?.length);
  return maxLength > 0 ? (
    <tbody>
      {Array.from({ length: maxLength })?.map((_, index) => (
        <tr key={index}>
          {/* Display team1 player */}
          <td>
            {team1Players?.[index] ? (
              <div className="player_inf">
                <div className="ply_des">
                  <span className="name">{team1Players[index]?.nm}</span>
                  {team1Players[index]?.pos && (
                    <span className="sub_name">
                      {team1Players[index]?.pos}
                    </span>
                  )}
                </div>
              </div>
            ) : (
              <span>-</span>
            )}
          </td>

          {/* Display team2 player */}
          <td>
            {team2Players?.[index] ? (
              <div className="player_inf">
                <div className="ply_des">
                  <span className="name">{team2Players[index]?.nm}</span>
                  {team2Players[index]?.pos && (
                    <span className="sub_name">
                      {team2Players[index]?.pos}
                    </span>
                  )}
                </div>
              </div>
            ) : (
              <span>-</span>
            )}
          </td>
        </tr>
      ))}
    </tbody>
  ) : (
    <NoDataFound />
  );
};

export default CricketPlayerTable;
